export class File {
    type: string;
	nid: string;
	role: string;
	pdf: string;
    nocFileData: any;
	errorFileBase64: string;
	fileBase64: string;
	extension: string;
}